const STORAGE_KEY = 'wolfwalker.qaqcPendingFailureNav';

/**
 * Parse query string from hash route e.g. #/qaqc?tab=failures&failure_id=1
 */
export function parseHashQuery() {
  const hash = window.location.hash.slice(1) || '/';
  const qIndex = hash.indexOf('?');
  if (qIndex < 0) return {};
  const search = hash.slice(qIndex + 1);
  const params = new URLSearchParams(search);
  const out = {};
  params.forEach((value, key) => {
    out[key] = value;
  });
  return out;
}

export function buildQaqcFailuresHash({ failureId, holeId, sampleNumber } = {}) {
  const params = new URLSearchParams();
  params.set('tab', 'failures');
  if (failureId != null && failureId !== '') {
    params.set('failure_id', String(failureId));
  }
  if (holeId) params.set('hole_id', holeId);
  if (sampleNumber) params.set('sample_number', sampleNumber);
  return `/qaqc?${params.toString()}`;
}

export function navigateToQaqcFailure(link) {
  if (!link) return;
  const payload = {
    tab: 'failures',
    failureId: link.failureId,
    holeId: link.holeId,
    sampleNumber: link.sampleNumber,
  };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
  window.location.hash = buildQaqcFailuresHash(link);
}

export function consumePendingFailureNav() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function readFailureNavFromHash() {
  const q = parseHashQuery();
  if (q.tab !== 'failures' && !q.failure_id && !q.hole_id && !q.sample_number) {
    return null;
  }
  return {
    tab: q.tab || 'failures',
    failureId: q.failure_id,
    holeId: q.hole_id,
    sampleNumber: q.sample_number,
  };
}
